import { JsonObject } from '../domain/types';

/** Indent used everywhere the module pretty-prints an editable payload. */
export const JSON_INDENT = 2;

export const NOT_AN_OBJECT_MESSAGE =
  'Enter a JSON object — arrays and primitive values are not accepted.';

export const stringifyJson = (value: JsonObject): string =>
  JSON.stringify(value, null, JSON_INDENT);

export interface JsonParseResult {
  /** The parsed object, or `null` when `error` is set. */
  value: JsonObject | null;
  /** A human-readable reason the text could not be used, or `null`. */
  error: string | null;
}

/**
 * Parses editor text into a `JsonObject`.
 *
 * PDGS stores `definition` as a JSONB *object*, so a syntactically valid
 * array or primitive is still rejected here rather than being sent and
 * failing server-side.
 */
export const parseJsonObject = (text: string): JsonParseResult => {
  let parsed: unknown;

  try {
    parsed = JSON.parse(text);
  } catch (error) {
    return {
      value: null,
      error: error instanceof Error ? error.message : 'Invalid JSON.',
    };
  }

  if (parsed === null || typeof parsed !== 'object' || Array.isArray(parsed)) {
    return { value: null, error: NOT_AN_OBJECT_MESSAGE };
  }

  return { value: parsed as JsonObject, error: null };
};
